import { type Achievement } from '@lingoda/graphql';

export const getIsClaimable = ({ achieved, claimed, claimId }: Achievement) => {
    return achieved && !claimed && !!claimId;
};
